<template>
  <div class='pb-24 w-full overflow-x-auto px-4 lg:px-8'>
    <custom-field v-for='(field, index) in drilldownInvestmentFiles'
      :key='`investment-files-${index}`'
      :custom-field='field'
      :is-horizontal='true'
      :is-view-mode='false'
      class='border-b border-dotted pb-4 mb-8' />
    <folder-item
      :folderData='investmentFolder'
      :investmentId='drilldownInvestmentId' />
    <portal to='sidepanel-footer'>
      <div v-if='hasDrilldownInvestmentFiles'
        class='pl-4 lg:pl-16 py-4 bg-gray-100'>
        <button
          class='border w-48 h-12 text-white rounded-md font-bold'
          style='background-color: #223645;'
          @click='submit()'>
          수정
        </button>
      </div>
    </portal>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import CustomField from '@/components/custom_fields/CustomField.vue'
import FolderItem  from '@/views/folder/FolderItem.vue'

export default {
  name: 'PiInvestmentFiles',
  components: {
    CustomField,
    FolderItem,
  },
  data () {
    return {
      investmentFolder: [],
    }
  },
  watch: {
    drilldownInvestmentId: {
      handler: function (newId) {
        if (newId > 0) {
          this.getCustomFieldsForInvestmentByType('file')
        }
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters('investments', [
      'drilldownInvestmentId',
      'drilldownInvestmentFiles',
      'drilldownPiInvestmentFiles',
      'hasDrilldownInvestmentFiles',
    ]),
  },
  methods: {
    ...mapActions('investments', [
      'updateAllCustomFieldValues',
      'getCustomFieldsForInvestmentByType'
    ]),
    submit () {
      this.updateAllCustomFieldValues(this.drilldownInvestmentId).then(() => {
        this.cloneInvestmentFolder()
      })
    },
  },
}
</script>
